import { create } from 'zustand';
import { fetchJobById, downloadJobQuestionsPackage, deleteJobQuestion, fetchJobQuestionErrors } from '../services/jobs.service';
import type { JobDetailsStore } from '../interfaces/storeInterfaces/jobDetailsStore';

export const useJobDetailsStore = create<JobDetailsStore>((set) => ({
    // Initial State
    job: null,
    isLoading: false,
    error: null,

    // Actions
    load: async (jobId, questionStatus) => {
        set({ isLoading: true, error: null });
        try {
            const response = await fetchJobById(jobId, { question_status: questionStatus });
            set({
                job: response,
                isLoading: false,
            });
        } catch (error) {
            const message = error instanceof Error ? error.message : 'Failed to load job details';
            set({ error: message, isLoading: false });
            console.error(`Failed to load job details for ID ${jobId}:`, error);
        }
    },

    downloadPackage: async (jobId, status) => {
        try {
            const result = await downloadJobQuestionsPackage(jobId, status);
            return result;
        } catch (error) {
            console.error(`Failed to request download package for job ${jobId}:`, error);
            throw error;
        }
    },

    deleteQuestion: async (jobId, questionId) => {
        try {
            await deleteJobQuestion(jobId, questionId);
        } catch (error) {
            console.error(`Failed to delete question ${questionId} from job ${jobId}:`, error);
            throw error;
        }
    },

    fetchQuestionErrors: async (jobId) => {
        try {
            const errors = await fetchJobQuestionErrors(jobId);
            return errors;
        } catch (error) {
            console.error(`Failed to fetch question errors for job ${jobId}:`, error);
            throw error;
        }
    },

    reset: () => set({ job: null, isLoading: false, error: null }),
}));
